import { DocsType } from "./constants";

export const flattenCommentArray = (commentArray) =>
  commentArray?.reduce((acc, x) => acc + (x.text ?? ""), "");

export const extractType = (typeInfo) => {
  if (typeInfo?.type === DocsType.Literal) {
    return `${typeInfo.value}`;
  }
  if (typeInfo?.type === DocsType.Reference) {
    if (typeInfo.typeArguments?.length > 0) {
      const args = typeInfo.typeArguments.map((a) => extractType(a));
      return `${typeInfo.name}<${args.join(", ")}>`;
    }
  }
  if (typeInfo?.type === DocsType.Reflection) {
    if (typeInfo.declaration?.signatures) {
      return "function";
    }
    return "object";
  }
  if (typeInfo?.type === DocsType.Tuple) {
    const elements = typeInfo.elements?.map((e) => extractType(e)) ?? [];
    return `[${elements.join(", ")}]`;
  }
  if (typeInfo?.type === DocsType.Union) {
    const parts = typeInfo.types?.map((t) => extractType(t)) ?? [];
    return parts.join(" | ");
  }
  if (typeInfo?.type === DocsType.Conditional) {
    const parts = [
      extractType(typeInfo.trueType),
      extractType(typeInfo.falseType),
    ];
    if (parts[0] === parts[1]) return parts[0];
    return parts.join(" | ");
  }
  if (typeInfo?.type === DocsType.Array) {
    const elementType = extractType(typeInfo.elementType);
    return `${elementType}[]`;
  }
  if (typeInfo?.type === DocsType.TypeOperator) {
    return extractType(typeInfo.target);
  }
  if (typeInfo?.name === "undefined") return "any";
  return typeInfo?.name;
};

export const extractDescription = (typeInfo) => {
  if (typeInfo?.type === DocsType.Reflection) {
    const signatures = typeInfo.declaration?.signatures;
    const signature =
      Array.isArray(signatures) && signatures.length > 0 ? signatures[0] : {};
    return flattenCommentArray(signature.comment?.summary);
  }
  return undefined;
};
